export default "assets/images/icons/slider-arrow-c6dd1c65.svg";